(() => {
  if (window.etFit4WinterCopyReady) return;
  window.etFit4WinterCopyReady = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-et-copy-coupon]');
    if (!button) return;
    const code = button.dataset.etCopyCoupon;
    let copied = false;
    try {
      await navigator.clipboard.writeText(code);
      copied = true;
    } catch {
      const field = document.createElement('textarea');
      field.value = code;
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.append(field);
      field.select();
      copied = document.execCommand('copy');
      field.remove();
      button.focus({ preventScroll: true });
    }
    if (!copied) return;
    const label = button.querySelector('[data-et-copy-label]');
    const original = label.textContent;
    label.textContent = button.dataset.etCopiedLabel;
    button.classList.add('is-copied');
    clearTimeout(button.etCopyReset);
    button.etCopyReset = setTimeout(() => {
      label.textContent = button.dataset.etCopyOriginal || original;
      button.classList.remove('is-copied');
    }, 2400);
    button.dataset.etCopyOriginal ||= original;
  });
})();
